import { render, staticRenderFns } from "./fi_fav_star.vue?vue&type=template&id=26bd2a85&scoped=true&"
import script from "./fi_fav_star.vue?vue&type=script&lang=js&"
export * from "./fi_fav_star.vue?vue&type=script&lang=js&"
import style0 from "./fi_fav_star.vue?vue&type=style&index=0&id=26bd2a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd2a85",
  null
  
)

export default component.exports